module.exports = __webpack_public_path__ + "img/ladrillos-tradicional.3a81178b.jpg";